export const POST_ONE_OBJECTIVE = "POST_ONE_OBJECTIVE"
export const POST_ONE_OBJECTIVE_FAIL = "POST_ONE_OBJECTIVE_FAIL"
export const PATCH_ONE_OBJECTIVE = "PATCH_ONE_OBJECTIVE"
export const PATCH_ONE_OBJECTIVE_FAIL = "PATCH_ONE_OBJECTIVE_FAIL"
export const FETCH_OBJECTIVES = "FETCH_OBJECTIVES"
export const FETCH_OBJECTIVES_FAIL = "FETCH_OKRS_FAIL"
export const FETCH_OBJECTIVE = "FETCH_OBJECTIVE"
export const FETCH_OBJECTIVE_FAIL = "FETCH_OBJECTIVE_FAIL"
export const LOADING_OBJECTIVES = "LOADING_OBJECTIVES"
export const DELETE_OBJECTIVE = "DELETE_OBJECTIVE"
export const CLEAR_OBJECTIVE = "CLEAR_OBJECTIVE"
export const CLEAR_OBJECTIVES = "CLEAR_OBJECTIVES"